import type { TsTypeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { LeafBlock } from '../leaf-block.js'

@jsonClass('PlaceholderBlock')
export class PlaceholderBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'input',
		order: 1,
		label: 'Name',
		contentType: 'text',
		elementType: 'input',
		isMandatory: () => true,
	})
	name: TsTypeType = 'content'

	constructor(init: Partial<PlaceholderBlock> = {}) {
		super()
		this.init(init)
	}

	getEditorTitle() {
		return `${super.getEditorTitle()} ${this.name}`
	}

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
